<template>
  <div>
    <slot :loaded="loaded" :total="total" />
  </div>
</template>

<script>
export default {
  name: 'ImgPreload',
  props: {
    imgs: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    const imgs = this.imgs.filter(item => !/^data/.test(item));
    return {
      loaded: 0,
      total: imgs.length
    };
  },
  methods: {
    loadImg(src) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = () => {
          this.$emit('progress', {
            loaded: this.loaded,
            total: this.total
          });
          resolve();
        };
        img.onerror = reject;
        img.src = src;
      });
    },
    load() {
      if (!this.total) {
        this.$emit('finish');
        return;
      }
      this.$emit('load-start');
      for (let i = 0; i < this.total; i++) {
        this.loadImg(this.imgs[i])
          .then(() => {
            this.loaded++;
            this.$nextTick(() => {
              if (this.loaded >= this.total) {
                this.$emit('finish');
              }
            });
          })
          .catch(err => {
            this.$emit('error', err);
          });
      }
    }
  }
};
</script>